import {useState, useCallback} from 'react'
import {useSnackbar} from 'notistack'
import {getGeneric} from '../../common/constants'

export function usePaceMerchantList() {
  const [isLoading, setIsLoading] = useState(false)
  const [brands, setBrands] = useState([])
  const [totalBrands, setTotalBrands] = useState(0)
  const {enqueueSnackbar} = useSnackbar()

  const loadBrands = useCallback(async () => {
    setIsLoading(true)
    setBrands([])
    setTotalBrands(0)
    try {
      const res = await getGeneric('dynamiccourier/pace/admin/brands')
      const data = res.data?.result || res.data?.data || res.data
      setBrands(data?.brands || [])
      setTotalBrands(data?.totalBrands || 0)
    } catch (err) {
      enqueueSnackbar('Failed to load PACE merchant list', {variant: 'error'})
    } finally {
      setIsLoading(false)
    }
  }, [enqueueSnackbar])

  return {isLoading, brands, totalBrands, loadBrands}
}
